import React from 'react';
import {
  Route,
} from 'react-router-dom';
import Avatar from '@material-ui/core/Avatar';
import CssBaseline from '@material-ui/core/CssBaseline';
import Paper from '@material-ui/core/Paper';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import { makeStyles } from '@material-ui/core/styles';
import SignInPage from '../../routes/SignIn';
import PasswordForgetPage from '../../routes/PasswordForget';
import MadeWithLove from '../made';
import * as ROUTES from '../../constants/routes';

const useStyles = makeStyles(theme => ({
  root: {
    height: '100vh',
  },
  image: {
    backgroundImage: 'url(/images/login-maclic.png)',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
  },
  paper: {
    margin: theme.spacing(8, 4),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.primary.main,
  },
}));

const AccessTemplate = () => {
  const classes = useStyles();
  return (
    <Grid container component="main" className={classes.root}>
      <CssBaseline />
      <Grid item xs={false} sm={4} md={7} className={classes.image} />
      <Grid item xs={12} sm={8} md={5} component={Paper} elevation={6} square>
        <div className={classes.paper}>
          <Avatar className={classes.avatar}>
            <LockOutlinedIcon />
          </Avatar>
          <Route exact path={ROUTES.SIGN_IN} component={SignInPage} />
          {/* <Route path={ROUTES.SIGN_UP} component={SignUpPage} /> */}
          <Route path={ROUTES.PASSWORD_FORGET} component={PasswordForgetPage} />
          <Box mt={5}>
            <MadeWithLove />
          </Box>
        </div>
      </Grid>
    </Grid>
  );
};

export default AccessTemplate;
